import type { DocumentDownloadContainerCoreProps } from '@gov-nx/ui/types';

export const DocumentDownloadContainer = ({
	children,
	label,
}: DocumentDownloadContainerCoreProps) => (
	<ul
		className="flex flex-wrap gap-4 gov-list--plain"
		aria-label={label}>
		{children}
	</ul>
);
